import { AppTypesType, DeviceOrientaionType } from '../types';

export interface DeviceData {
  appVersion?: string; // 0.2.0.92 -> iOS app works with new structure on 92+
  appType?: AppTypesType;
  deviceOrientation: DeviceOrientaionType;
  gyroAccelerometerFile?: string;
  gyroRotationFile?: string;
  phoneCameraSettings?: string;
  phoneModel?: string;
  stabilizerPriorityLevel?: string; // refers to camera stabilization method
}

export class DeviceDataClass implements DeviceData {
  appVersion?: string;
  appType?: AppTypesType;
  deviceOrientation: DeviceOrientaionType;
  gyroAccelerometerFile?: string | undefined;
  gyroRotationFile?: string | undefined;
  phoneCameraSettings?: string | undefined;
  phoneModel?: string | undefined;
  stabilizerPriorityLevel?: string | undefined;

  constructor(o: any = {}) {
    this.appVersion = o['appVersion'] ?? null;
    this.appType = o['appType'] ?? null;
    this.deviceOrientation = o['deviceOrientation'] ?? null;
    this.gyroAccelerometerFile = o['gyroAccelerometerFile'] ?? null;
    this.gyroRotationFile = o['gyroRotationFile'] ?? null;
    this.phoneCameraSettings = o['phoneCameraSettings'] ?? null;
    this.phoneModel = o['phoneModel'] ?? null;
    this.stabilizerPriorityLevel = o['stabilizerPriorityLevel'] ?? null;
  }
}
